import SVG from "@Components/Icons/SVG";
export default class BillReports extends SVG {
    path = [
        "M 56.1874 46.5075 H 28.1075 M 37.4675 65.2274 H 28.1075 M 65.5475 27.7875 H 28.1075 M 84.2674 44.1674 V 26.8515 C 84.2674 18.9884 84.2674 15.0568 82.7374 12.0535 C 81.3913 9.4117 79.2432 7.2638 76.6015 5.9178 C 73.598 4.3875 69.6665 4.3875 61.8034 4.3875 H 31.8515 C 23.9884 4.3875 20.0568 4.3875 17.0535 5.9178 C 14.4117 7.2638 12.2638 9.4117 10.9178 12.0535 C 9.3875 15.0568 9.3875 18.9884 9.3875 26.8515 V 75.5236 C 9.3875 83.3867 9.3875 87.3183 10.9178 90.3214 C 12.2638 92.9634 14.4117 95.1112 17.0535 96.4573 C 20.0568 97.9876 23.9884 97.9876 31.8515 97.9876 H 44.4875 M 93.6275 97.9876 L 86.6075 90.9676 M 91.2874 79.2674 C 91.2874 88.3141 83.9539 95.6475 74.9076 95.6475 C 65.8609 95.6475 58.5275 88.3141 58.5275 79.2674 C 58.5275 70.2211 65.8609 62.8876 74.9076 62.8876 C 83.9539 62.8876 91.2874 70.2211 91.2874 79.2674 Z",
    ];
    strokeDetails = {
        stroke: "black",
        strokeWidth: "6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };
    evenOdd = true;
}
